import { useQuery } from "react-query";
import { ECoursesQueryKeys } from "api/endpoints/courses";
import { getCourseLessonById } from "api/services/courses";
import { logError } from "utils/notifications";
import { TCourseLesson } from "types/api/course";
import { TApiError } from "types/api/error";

export const useCourseLessonById = (
  courseId?: string | number,
  lessonId?: string | number
) => {
  return useQuery<TCourseLesson, TApiError>(
    [ECoursesQueryKeys.getCourseLessonById, courseId, lessonId],
    () => getCourseLessonById(courseId, lessonId),
    {
      onError: (error) => logError({ error }),
      retry: false,
      enabled: courseId !== undefined && lessonId !== undefined,
    }
  );
};
